import { render, staticRenderFns } from "./PanelValidationFailedModal.vue?vue&type=template&id=204c78d0&scoped=true&"
import script from "./PanelValidationFailedModal.vue?vue&type=script&lang=js&"
export * from "./PanelValidationFailedModal.vue?vue&type=script&lang=js&"
import style0 from "./PanelValidationFailedModal.vue?vue&type=style&index=0&id=204c78d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c78d0",
  null
  
)

export default component.exports